/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_FinishedInputs */

const bn_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সমাপ্ত`)
};

const de_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const el_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πεπερασμένος`)
};

const en_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished`)
};

const es_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

const fr_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const hi_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खत्म`)
};

const hu_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befejezett`)
};

const id_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai`)
};

const it_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finito`)
};

const ja_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了した`)
};

const ko_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완성된`)
};

const nl_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgerond`)
};

const pl_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy`)
};

const pt_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

const ru_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Законченный`)
};

const sv_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Färdig`)
};

const tr_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitmiş`)
};

const uk_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово`)
};

const vi_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành`)
};

const zh_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成的`)
};

const zh_hant_game_finished = /** @type {(inputs: Game_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成的`)
};

/**
* | output |
* | --- |
* | "Finished" |
*
* @param {Game_FinishedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_finished = /** @type {((inputs?: Game_FinishedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_FinishedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_finished(inputs)
	if (locale === "de") return de_game_finished(inputs)
	if (locale === "el") return el_game_finished(inputs)
	if (locale === "en") return en_game_finished(inputs)
	if (locale === "es") return es_game_finished(inputs)
	if (locale === "fr") return fr_game_finished(inputs)
	if (locale === "hi") return hi_game_finished(inputs)
	if (locale === "hu") return hu_game_finished(inputs)
	if (locale === "id") return id_game_finished(inputs)
	if (locale === "it") return it_game_finished(inputs)
	if (locale === "ja") return ja_game_finished(inputs)
	if (locale === "ko") return ko_game_finished(inputs)
	if (locale === "nl") return nl_game_finished(inputs)
	if (locale === "pl") return pl_game_finished(inputs)
	if (locale === "pt") return pt_game_finished(inputs)
	if (locale === "ru") return ru_game_finished(inputs)
	if (locale === "sv") return sv_game_finished(inputs)
	if (locale === "tr") return tr_game_finished(inputs)
	if (locale === "uk") return uk_game_finished(inputs)
	if (locale === "vi") return vi_game_finished(inputs)
	if (locale === "zh") return zh_game_finished(inputs)
	return zh_hant_game_finished(inputs)
});